import { render, staticRenderFns } from "./SpinnerPaylinesRtpContribution.vue?vue&type=template&id=b47966fe&"
import script from "./SpinnerPaylinesRtpContribution.vue?vue&type=script&lang=js&"
export * from "./SpinnerPaylinesRtpContribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports